module.exports = __webpack_public_path__ + "static/img/Group393.5a2c79a.png";


//////////////////
// WEBPACK FOOTER
// ./src/newpage/static/images/complaint-record/Group393.png
// module id = pNcf
// module chunks = 1